import React, { Fragment, useState, useEffect, } from 'react'; 
import Header from "../common/header";
import Footer from "../common/footer";  
import WhyMarquisBanner from "./why-marquis-banner";
import WhyMarquisDescription from "./why-marquis-description"; 

import { fetchWhyMarquisPageData } from "./fetchWhyMarquisPageData";

import logo from "../../assets/marquis-logo.svg";
import * as apiUrl from "../../apiUrl";


function WhyMarquisPage() {

  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Function to preload images
  const preloadImages = async (imageUrls) => {
    const promises = imageUrls.map((url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;

        img.onload = () => resolve(url);
        img.onerror = (error) => {
          console.error(`Failed to load image: ${url}`, error);
          reject(error);
        };
      });
    });

    try {
      await Promise.all(promises);
      setIsLoading(false);
    } catch (error) {
      console.error("Error preloading some images:", error);
    }
  };

  useEffect(() => {
    const loadPageData = async () => {
      try {
        const data = await fetchWhyMarquisPageData();
        setPageData(data); // Set page data after preloading

        if (data) {
          // Extract and prepare image URLs for preloading
          const imageUrls = [
            data.banner.banner_image,           
          ]
            .filter(Boolean)
            .map((image) => `${apiUrl.apiUrl}/${image}`);

          // Render page content first, then preload images

          preloadImages(imageUrls);
        }
      } catch (error) {
        console.error("Error loading page data or images:", error);
        setIsLoading(false);
      }
    };

    loadPageData();
  }, []);

  if (isLoading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }
  
  return (
    <Fragment> 
    <Header />

    <WhyMarquisBanner data={pageData.banner} />
    <WhyMarquisDescription data={pageData.second} /> 
    <Footer /> 

</Fragment> 
  );
}

export default WhyMarquisPage;